/**
 * Görsel Üretim Sözleşmesi — visualGenerationModel
 *
 * Bu modül gerçek bir sağlayıcı bağlantısı içermez.
 * Sağlayıcı bağlandığında bu sözleşme değişmeden kalır.
 *
 * KURAL: Bu modül hiçbir ağ çağrısı yapmaz.
 *        Sağlayıcı yoksa tüm üretim eylemleri engellenir (fail-closed).
 *        Sonuç her zaman candidate_only — doğrudan DB'ye yazılmaz.
 */

export const SCHEMA_VERSION = 1;

/**
 * Görsel üretim sonucu sözleşme türü.
 * Üretilen görsel doğrudan DB'ye yazılmaz; yalnızca aday (candidate) olarak döner.
 * Kullanıcı "Bu soruda dene" veya "Taslağa bağla" ile işlem yapar.
 */
export const GENERATION_RESULT_CONTRACT = /** @type {const} */ ('candidate_only');

/**
 * Sağlayıcı durumları.
 */
export const PROVIDER_STATUS = /** @type {const} */ ({
  NONE:      'none',       // Sağlayıcı bağlanmadı
  CONNECTED: 'connected',  // Sağlayıcı bağlı ve hazır
  ERROR:     'error',      // Sağlayıcı bağlı fakat hatalı durum
});

/**
 * Üretim sonrası eylemler — iki ayrı callback olarak tanımlanır.
 */
export const GENERATION_ACTION = /** @type {const} */ ({
  TRY_ON_QUESTION: 'try_on_question',  // "Bu soruda dene" — yerel state sandbox, API yazma yok
  ATTACH_TO_DRAFT: 'attach_to_draft',  // "Taslağa bağla" — Media V2 binding taslağına yazar
});

/**
 * Hangi usage_key'ler görsel üretim için uygun?
 * Ses, altyazı ve doküman türleri dahil değil.
 */
export const GENERATABLE_USAGE_KEYS = [
  'question.primary_visual',
  'question.gif',
  'question.explanation_visual',
  'option.visual',
];

/**
 * Üretim aday sonucu şeması.
 * Sağlayıcı bağlıyken her iki callback'e bu yapı geçirilir.
 *
 * @typedef {Object} GenerationCandidate
 * @property {'candidate_only'}  contract       - Sonuç türü (sabit, değiştirilemez)
 * @property {string}            usage_key      - Hedef usage key
 * @property {string|null}       option_key     - Şık hedefi (option.visual ise zorunlu)
 * @property {string}            playback_url   - Üretilen görselin geçici URL'i
 * @property {'image'|'gif'}     media_type     - Medya türü
 * @property {string}            provider_name  - Sağlayıcı tanımlayıcısı
 * @property {string}            generated_at   - ISO-8601 timestamp
 */

/**
 * Sağlayıcı bağlantı sözleşmesi.
 * Gerçek sağlayıcı entegrasyonu bu şemayı doldurmalıdır.
 *
 * @typedef {Object} ProviderContract
 * @property {string}        name      - Sağlayıcı adı (görüntülenir)
 * @property {'connected'|'error'|'none'} status
 * @property {string|null}   error_msg - Hata varsa mesaj
 */
